// // // import React, { useState, useRef } from "react";
// // // import emailjs from "@emailjs/browser";
// // // import "./BookingModal.css";

// // // const BookingModal = ({ isOpen, onClose }) => {
// // //   const [formData, setFormData] = useState({
// // //     name: "",
// // //     email: "",
// // //     message: "",
// // //   });
// // //   const [isSubmitting, setIsSubmitting] = useState(false);
// // //   const [submitStatus, setSubmitStatus] = useState(null); // 'success' or 'error'
// // //   const formRef = useRef();

// // //   // Initialize EmailJS with your public key
// // //   // Sign up at https://www.emailjs.com/ to get these keys
// // //   const EMAILJS_SERVICE_ID = "service_990alll"; // Replace with your service ID
// // //   const EMAILJS_TEMPLATE_ID = "template_6puxneq"; // Replace with your template ID
// // //   const EMAILJS_PUBLIC_KEY = "nw26uUAjZdp_YqTd8"; // Replace with your public key

// // //   const handleChange = (e) => {
// // //     const { name, value } = e.target;
// // //     setFormData((prev) => ({
// // //       ...prev,
// // //       [name]: value,
// // //     }));
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     setIsSubmitting(true);
// // //     setSubmitStatus(null);

// // //     try {
// // //       // Initialize EmailJS
// // //       emailjs.init(EMAILJS_PUBLIC_KEY);

// // //       // Prepare template parameters
// // //       const templateParams = {
// // //         to_email: "info@hnu.ie",
// // //         from_name: formData.name,
// // //         from_email: formData.email,
// // //         message: formData.message,
// // //       };

// // //       // Send email
// // //       const response = await emailjs.send(
// // //         EMAILJS_SERVICE_ID,
// // //         EMAILJS_TEMPLATE_ID,
// // //         templateParams,
// // //       );

// // //       console.log("Email sent successfully:", response);
// // //       setSubmitStatus("success");

// // //       // Reset form after success
// // //       setFormData({
// // //         name: "",
// // //         email: "",
// // //         message: "",
// // //       });

// // //       // Close modal after 2 seconds
// // //       setTimeout(() => {
// // //         onClose();
// // //         setSubmitStatus(null);
// // //       }, 2000);
// // //     } catch (error) {
// // //       console.error("Error sending email:", error);
// // //       setSubmitStatus("error");
// // //       setIsSubmitting(false);
// // //     }
// // //   };

// // //   const handleClose = () => {
// // //     if (!isSubmitting) {
// // //       setFormData({
// // //         name: "",
// // //         email: "",
// // //         message: "",
// // //       });
// // //       setSubmitStatus(null);
// // //       onClose();
// // //     }
// // //   };

// // //   if (!isOpen) return null;

// // //   return (
// // //     <div className="modal-overlay" onClick={handleClose}>
// // //       <div className="modal-container" onClick={(e) => e.stopPropagation()}>
// // //         <button
// // //           className="modal-close-btn"
// // //           onClick={handleClose}
// // //           disabled={isSubmitting}
// // //         >
// // //           <i className="fas fa-times"></i>
// // //         </button>

// // //         <h2 className="modal-title">Book an Appointment</h2>
// // //         <p className="modal-subtitle">
// // //           Fill in your details and we'll get back to you as soon as possible.
// // //         </p>

// // //         {submitStatus === "success" ? (
// // //           <div className="success-message">
// // //             <i className="fas fa-check-circle"></i>
// // //             <p>
// // //               Your message has been sent successfully! We'll contact you
// // //               shortly.
// // //             </p>
// // //           </div>
// // //         ) : (
// // //           <form ref={formRef} onSubmit={handleSubmit} className="booking-form">
// // //             <div className="form-group">
// // //               <label htmlFor="name">Name *</label>
// // //               <input
// // //                 type="text"
// // //                 id="name"
// // //                 name="name"
// // //                 value={formData.name}
// // //                 onChange={handleChange}
// // //                 required
// // //                 placeholder="John Doe"
// // //                 disabled={isSubmitting}
// // //               />
// // //             </div>

// // //             <div className="form-group">
// // //               <label htmlFor="email">Contact Email *</label>
// // //               <input
// // //                 type="email"
// // //                 id="email"
// // //                 name="email"
// // //                 value={formData.email}
// // //                 onChange={handleChange}
// // //                 required
// // //                 placeholder="john@example.com"
// // //                 disabled={isSubmitting}
// // //               />
// // //             </div>

// // //             <div className="form-group">
// // //               <label htmlFor="message">Message *</label>
// // //               <textarea
// // //                 id="message"
// // //                 name="message"
// // //                 value={formData.message}
// // //                 onChange={handleChange}
// // //                 required
// // //                 placeholder="Tell us about your requirements..."
// // //                 rows="4"
// // //                 disabled={isSubmitting}
// // //               />
// // //             </div>

// // //             {submitStatus === "error" && (
// // //               <div className="error-message">
// // //                 <i className="fas fa-exclamation-circle"></i>
// // //                 <p>Something went wrong. Please try again later.</p>
// // //               </div>
// // //             )}

// // //             <button
// // //               type="submit"
// // //               className="submit-btn"
// // //               disabled={isSubmitting}
// // //             >
// // //               {isSubmitting ? (
// // //                 <>
// // //                   <span className="spinner"></span>
// // //                   Sending...
// // //                 </>
// // //               ) : (
// // //                 "Send Message"
// // //               )}
// // //             </button>
// // //           </form>
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default BookingModal;

// // import React, { useState, useRef, useEffect } from "react";
// // import emailjs from "@emailjs/browser";
// // import { Turnstile } from "@marsidev/react-turnstile";
// // import "./BookingModal.css";

// // const BookingModal = ({ isOpen, onClose }) => {
// //   const [formData, setFormData] = useState({
// //     name: "",
// //     email: "",
// //     package: "",
// //     date: "",
// //     time: "",
// //     message: "",
// //   });
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [submitStatus, setSubmitStatus] = useState(null);
// //   const [turnstileToken, setTurnstileToken] = useState(null);
// //   const [turnstileError, setTurnstileError] = useState(false);
// //   const [turnstileReady, setTurnstileReady] = useState(false);
// //   const formRef = useRef();
// //   const turnstileRef = useRef();

// //   // Cloudflare Turnstile Site Key - Make sure this is correct
// //   const TURNSTILE_SITE_KEY = "0x4AAAAAAESqFbuUZIDyVjHu"; // Replace with your site key

// //   // EmailJS Configuration
// //   const EMAILJS_SERVICE_ID = "service_990alll";
// //   const EMAILJS_TEMPLATE_ID = "template_6puxneq";
// //   const EMAILJS_PUBLIC_KEY = "nw26uUAjZdp_YqTd8";

// //   // Package options
// //   const packages = [
// //     {
// //       value: "sole-trader",
// //       label: "Sole Trader/PAYE",
// //       price: "€150-250",
// //       description: "Annual Income Tax Return, Revenue compliance",
// //     },
// //     {
// //       value: "sme",
// //       label: "Small-Medium Enterprises",
// //       price: "€150-500",
// //       description: "Monthly bookkeeping, VAT returns, Payroll",
// //     },
// //     {
// //       value: "startup",
// //       label: "Start-up Business",
// //       price: "€250",
// //       description: "CRO registration, Company formation, Revenue Registration",
// //     },
// //   ];

// //   // Generate future dates (from tomorrow onwards)
// //   const getFutureDates = () => {
// //     const dates = [];
// //     const today = new Date();
// //     for (let i = 1; i <= 14; i++) {
// //       const date = new Date(today);
// //       date.setDate(today.getDate() + i);
// //       dates.push(date);
// //     }
// //     return dates;
// //   };

// //   const formatDate = (date) => {
// //     return date.toLocaleDateString("en-IE", {
// //       weekday: "short",
// //       day: "numeric",
// //       month: "short",
// //       year: "numeric",
// //     });
// //   };

// //   const formatDateValue = (date) => {
// //     return date.toISOString().split("T")[0];
// //   };

// //   const timeSlots = [
// //     "09:00",
// //     "09:30",
// //     "10:00",
// //     "10:30",
// //     "11:00",
// //     "11:30",
// //     "12:00",
// //     "12:30",
// //     "13:00",
// //     "13:30",
// //     "14:00",
// //     "14:30",
// //     "15:00",
// //     "15:30",
// //     "16:00",
// //     "16:30",
// //     "17:00",
// //   ];

// //   // Reset Turnstile when modal opens
// //   useEffect(() => {
// //     if (isOpen) {
// //       setTurnstileToken(null);
// //       setTurnstileError(false);
// //       setTurnstileReady(false);
// //       // Reset form data
// //       setFormData({
// //         name: "",
// //         email: "",
// //         package: "",
// //         date: "",
// //         time: "",
// //         message: "",
// //       });
// //     }
// //   }, [isOpen]);

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prev) => ({
// //       ...prev,
// //       [name]: value,
// //     }));
// //   };

// //   const validateEmail = (email) => {
// //     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// //     return re.test(email);
// //   };

// //   const handleTurnstileSuccess = (token) => {
// //     console.log("Turnstile verification successful:", token);
// //     setTurnstileToken(token);
// //     setTurnstileError(false);
// //     setTurnstileReady(true);
// //   };

// //   const handleTurnstileError = () => {
// //     console.error("Turnstile verification failed");
// //     setTurnstileToken(null);
// //     setTurnstileError(true);
// //     setTurnstileReady(false);
// //   };

// //   const handleTurnstileExpire = () => {
// //     console.log("Turnstile token expired");
// //     setTurnstileToken(null);
// //     setTurnstileError(true);
// //     setTurnstileReady(false);
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     // Validate Turnstile
// //     if (!turnstileToken) {
// //       setTurnstileError(true);
// //       alert("Please complete the security verification.");
// //       return;
// //     }

// //     // Validate email
// //     if (!validateEmail(formData.email)) {
// //       alert("Please enter a valid email address.");
// //       return;
// //     }

// //     // Validate all required fields
// //     if (
// //       !formData.name ||
// //       !formData.package ||
// //       !formData.date ||
// //       !formData.time
// //     ) {
// //       alert("Please fill in all required fields.");
// //       return;
// //     }

// //     setIsSubmitting(true);
// //     setSubmitStatus(null);

// //     try {
// //       emailjs.init(EMAILJS_PUBLIC_KEY);

// //       const selectedPackage = packages.find(
// //         (p) => p.value === formData.package,
// //       );

// //       const templateParams = {
// //         to_email: "info@hnu.ie",
// //         from_name: formData.name,
// //         from_email: formData.email,
// //         package_name: selectedPackage ? selectedPackage.label : "Not specified",
// //         package_price: selectedPackage
// //           ? selectedPackage.price
// //           : "Not specified",
// //         appointment_date: formData.date
// //           ? formatDate(new Date(formData.date))
// //           : "Not specified",
// //         appointment_time: formData.time || "Not specified",
// //         message: formData.message || "No message provided",
// //         turnstile_token: turnstileToken,
// //       };

// //       const response = await emailjs.send(
// //         EMAILJS_SERVICE_ID,
// //         EMAILJS_TEMPLATE_ID,
// //         templateParams,
// //       );

// //       console.log("Email sent successfully:", response);
// //       setSubmitStatus("success");

// //       setFormData({
// //         name: "",
// //         email: "",
// //         package: "",
// //         date: "",
// //         time: "",
// //         message: "",
// //       });
// //       setTurnstileToken(null);
// //       setTurnstileReady(false);

// //       setTimeout(() => {
// //         onClose();
// //         setSubmitStatus(null);
// //       }, 2000);
// //     } catch (error) {
// //       console.error("Error sending email:", error);
// //       setSubmitStatus("error");
// //       setIsSubmitting(false);
// //     }
// //   };

// //   const handleClose = () => {
// //     if (!isSubmitting) {
// //       setFormData({
// //         name: "",
// //         email: "",
// //         package: "",
// //         date: "",
// //         time: "",
// //         message: "",
// //       });
// //       setSubmitStatus(null);
// //       setTurnstileToken(null);
// //       setTurnstileError(false);
// //       setTurnstileReady(false);
// //       onClose();
// //     }
// //   };

// //   if (!isOpen) return null;

// //   return (
// //     <div className="modal-overlay" onClick={handleClose}>
// //       <div className="modal-container" onClick={(e) => e.stopPropagation()}>
// //         <button
// //           className="modal-close-btn"
// //           onClick={handleClose}
// //           disabled={isSubmitting}
// //         >
// //           <i className="fas fa-times"></i>
// //         </button>

// //         <h2 className="modal-title">Book an Appointment</h2>
// //         <p className="modal-subtitle">
// //           Fill in your details and we'll get back to you as soon as possible.
// //         </p>

// //         {submitStatus === "success" ? (
// //           <div className="success-message">
// //             <i className="fas fa-check-circle"></i>
// //             <p>
// //               Your appointment request has been sent successfully! We'll contact
// //               you shortly to confirm.
// //             </p>
// //           </div>
// //         ) : (
// //           <form ref={formRef} onSubmit={handleSubmit} className="booking-form">
// //             {/* Name Field */}
// //             <div className="form-group">
// //               <label htmlFor="name">Full Name *</label>
// //               <input
// //                 type="text"
// //                 id="name"
// //                 name="name"
// //                 value={formData.name}
// //                 onChange={handleChange}
// //                 required
// //                 placeholder="John Doe"
// //                 disabled={isSubmitting}
// //               />
// //             </div>

// //             {/* Email Field */}
// //             <div className="form-group">
// //               <label htmlFor="email">Email Address *</label>
// //               <input
// //                 type="email"
// //                 id="email"
// //                 name="email"
// //                 value={formData.email}
// //                 onChange={handleChange}
// //                 required
// //                 placeholder="john@example.com"
// //                 disabled={isSubmitting}
// //                 className={
// //                   formData.email && !validateEmail(formData.email)
// //                     ? "invalid"
// //                     : ""
// //                 }
// //               />
// //               {formData.email && !validateEmail(formData.email) && (
// //                 <p className="field-error">
// //                   Please enter a valid email address
// //                 </p>
// //               )}
// //             </div>

// //             {/* Package Selection */}
// //             <div className="form-group">
// //               <label htmlFor="package">Select Package *</label>
// //               <select
// //                 id="package"
// //                 name="package"
// //                 value={formData.package}
// //                 onChange={handleChange}
// //                 required
// //                 disabled={isSubmitting}
// //                 className="package-select"
// //               >
// //                 <option value="">Choose a package...</option>
// //                 {packages.map((pkg) => (
// //                   <option key={pkg.value} value={pkg.value}>
// //                     {pkg.label} - {pkg.price} ({pkg.description})
// //                   </option>
// //                 ))}
// //               </select>
// //             </div>

// //             {/* Date and Time */}
// //             <div className="form-row">
// //               <div className="form-group form-group-half">
// //                 <label htmlFor="date">Appointment Date *</label>
// //                 <select
// //                   id="date"
// //                   name="date"
// //                   value={formData.date}
// //                   onChange={handleChange}
// //                   required
// //                   disabled={isSubmitting}
// //                   className="date-select"
// //                 >
// //                   <option value="">Select a date...</option>
// //                   {getFutureDates().map((date) => (
// //                     <option
// //                       key={date.toISOString()}
// //                       value={formatDateValue(date)}
// //                     >
// //                       {formatDate(date)}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>

// //               <div className="form-group form-group-half">
// //                 <label htmlFor="time">Preferred Time *</label>
// //                 <select
// //                   id="time"
// //                   name="time"
// //                   value={formData.time}
// //                   onChange={handleChange}
// //                   required
// //                   disabled={isSubmitting}
// //                   className="time-select"
// //                 >
// //                   <option value="">Select a time...</option>
// //                   {timeSlots.map((time) => (
// //                     <option key={time} value={time}>
// //                       {time}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>
// //             </div>

// //             {/* Message Field */}
// //             <div className="form-group">
// //               <label htmlFor="message">Brief Message</label>
// //               <input
// //                 type="text"
// //                 id="message"
// //                 name="message"
// //                 value={formData.message}
// //                 onChange={handleChange}
// //                 placeholder="Any additional details about your requirements..."
// //                 disabled={isSubmitting}
// //                 className="message-input"
// //               />
// //             </div>

// //             {/* Cloudflare Turnstile with proper configuration */}
// //             <div className="form-group turnstile-group">
// //               <Turnstile
// //                 ref={turnstileRef}
// //                 siteKey={TURNSTILE_SITE_KEY}
// //                 onSuccess={handleTurnstileSuccess}
// //                 onError={handleTurnstileError}
// //                 onExpire={handleTurnstileExpire}
// //                 options={{
// //                   theme: "light",
// //                   size: "normal",
// //                   language: "en",
// //                   "response-field": true,
// //                   "response-field-name": "cf-turnstile-response",
// //                 }}
// //               />
// //               {turnstileError && (
// //                 <p className="turnstile-error">
// //                   <i className="fas fa-exclamation-circle"></i>
// //                   Please complete the security verification.
// //                 </p>
// //               )}
// //               {turnstileToken && (
// //                 <p className="turnstile-success">
// //                   <i className="fas fa-check-circle"></i>
// //                   Verification successful!
// //                 </p>
// //               )}
// //             </div>

// //             {submitStatus === "error" && (
// //               <div className="error-message">
// //                 <i className="fas fa-exclamation-circle"></i>
// //                 <p>Something went wrong. Please try again later.</p>
// //               </div>
// //             )}

// //             <button
// //               type="submit"
// //               className="submit-btn"
// //               disabled={isSubmitting || !turnstileToken}
// //             >
// //               {isSubmitting ? (
// //                 <>
// //                   <span className="spinner"></span>
// //                   Sending...
// //                 </>
// //               ) : (
// //                 "Book Appointment"
// //               )}
// //             </button>
// //           </form>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default BookingModal;

// import React, { useState, useRef, useEffect } from "react";
// import emailjs from "@emailjs/browser";
// import "./BookingModal.css";

// const BookingModal = ({ isOpen, onClose }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     package: "",
//     date: "",
//     time: "",
//     message: "",
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitStatus, setSubmitStatus] = useState(null);
//   const [turnstileToken, setTurnstileToken] = useState(null);
//   const [turnstileError, setTurnstileError] = useState(false);
//   const [turnstileLoaded, setTurnstileLoaded] = useState(false);
//   const formRef = useRef();
//   const turnstileContainerRef = useRef(null);
//   const widgetIdRef = useRef(null);
//   const scriptLoadedRef = useRef(false);

//   // Cloudflare Turnstile Site Key
//   const TURNSTILE_SITE_KEY = "0x4AAAAAAESqFbuUZIDyVjHu"; // Your site key

//   // EmailJS Configuration
//   const EMAILJS_SERVICE_ID = "service_990alll";
//   const EMAILJS_TEMPLATE_ID = "template_6puxneq";
//   const EMAILJS_PUBLIC_KEY = "nw26uUAjZdp_YqTd8";

//   // Package options
//   const packages = [
//     {
//       value: "sole-trader",
//       label: "Sole Trader/PAYE",
//       price: "€150-250",
//       description: "Annual Income Tax Return, Revenue compliance",
//     },
//     {
//       value: "sme",
//       label: "Small-Medium Enterprises",
//       price: "€150-500",
//       description: "Monthly bookkeeping, VAT returns, Payroll",
//     },
//     {
//       value: "startup",
//       label: "Start-up Business",
//       price: "€250",
//       description: "CRO registration, Company formation, Revenue Registration",
//     },
//   ];

//   // Generate future dates
//   const getFutureDates = () => {
//     const dates = [];
//     const today = new Date();
//     for (let i = 1; i <= 14; i++) {
//       const date = new Date(today);
//       date.setDate(today.getDate() + i);
//       dates.push(date);
//     }
//     return dates;
//   };

//   const formatDate = (date) => {
//     return date.toLocaleDateString("en-IE", {
//       weekday: "short",
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const formatDateValue = (date) => {
//     return date.toISOString().split("T")[0];
//   };

//   const timeSlots = [
//     "09:00",
//     "09:30",
//     "10:00",
//     "10:30",
//     "11:00",
//     "11:30",
//     "12:00",
//     "12:30",
//     "13:00",
//     "13:30",
//     "14:00",
//     "14:30",
//     "15:00",
//     "15:30",
//     "16:00",
//     "16:30",
//     "17:00",
//   ];

//   // Load Turnstile script
//   useEffect(() => {
//     // Load script only when modal is open
//     if (isOpen && !scriptLoadedRef.current) {
//       loadTurnstileScript();
//     }

//     return () => {
//       // Cleanup widget when modal closes
//       if (!isOpen && window.turnstile && widgetIdRef.current) {
//         try {
//           window.turnstile.remove(widgetIdRef.current);
//           widgetIdRef.current = null;
//         } catch (error) {
//           console.error("Error removing Turnstile widget:", error);
//         }
//       }
//     };
//   }, [isOpen]);

//   // Render Turnstile when container is ready
//   useEffect(() => {
//     if (
//       isOpen &&
//       turnstileLoaded &&
//       turnstileContainerRef.current &&
//       window.turnstile
//     ) {
//       // Small delay to ensure DOM is ready
//       const timer = setTimeout(() => {
//         renderTurnstileWidget();
//       }, 100);
//       return () => clearTimeout(timer);
//     }
//   }, [isOpen, turnstileLoaded]);

//   // Reset when modal opens
//   useEffect(() => {
//     if (isOpen) {
//       setTurnstileToken(null);
//       setTurnstileError(false);
//       setFormData({
//         name: "",
//         email: "",
//         package: "",
//         date: "",
//         time: "",
//         message: "",
//       });
//     }
//   }, [isOpen]);

//   const loadTurnstileScript = () => {
//     // Check if script already exists
//     if (document.querySelector('script[src*="turnstile"]')) {
//       if (window.turnstile) {
//         setTurnstileLoaded(true);
//         scriptLoadedRef.current = true;
//         return;
//       }
//     }

//     // Create and load script
//     const script = document.createElement("script");
//     script.src =
//       "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
//     script.async = true;
//     script.defer = true;
//     script.onload = () => {
//       console.log("Turnstile script loaded");
//       setTurnstileLoaded(true);
//       scriptLoadedRef.current = true;
//     };
//     script.onerror = (error) => {
//       console.error("Failed to load Turnstile script:", error);
//       setTurnstileError(true);
//     };
//     document.head.appendChild(script);
//   };

//   const renderTurnstileWidget = () => {
//     // Safety checks
//     if (!window.turnstile) {
//       console.error("Turnstile not available");
//       return;
//     }

//     if (!turnstileContainerRef.current) {
//       console.error("Turnstile container not found");
//       return;
//     }

//     // Remove existing widget if any
//     if (widgetIdRef.current) {
//       try {
//         window.turnstile.remove(widgetIdRef.current);
//         widgetIdRef.current = null;
//       } catch (error) {
//         console.error("Error removing existing widget:", error);
//       }
//     }

//     try {
//       // Render the widget
//       const widgetId = window.turnstile.render(turnstileContainerRef.current, {
//         sitekey: TURNSTILE_SITE_KEY,
//         theme: "light",
//         size: "normal",
//         language: "en",
//         callback: function (token) {
//           console.log("Turnstile verification successful");
//           setTurnstileToken(token);
//           setTurnstileError(false);
//         },
//         "error-callback": function (error) {
//           console.error("Turnstile error:", error);
//           setTurnstileToken(null);
//           setTurnstileError(true);
//         },
//         "expired-callback": function () {
//           console.log("Turnstile token expired");
//           setTurnstileToken(null);
//           setTurnstileError(true);
//         },
//       });

//       widgetIdRef.current = widgetId;
//       console.log("Turnstile widget rendered with ID:", widgetId);
//     } catch (error) {
//       console.error("Error rendering Turnstile widget:", error);
//       setTurnstileError(true);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const validateEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(email);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate Turnstile
//     if (!turnstileToken) {
//       setTurnstileError(true);
//       alert("Please complete the security verification.");
//       return;
//     }

//     // Validate email
//     if (!validateEmail(formData.email)) {
//       alert("Please enter a valid email address.");
//       return;
//     }

//     // Validate all required fields
//     if (
//       !formData.name ||
//       !formData.package ||
//       !formData.date ||
//       !formData.time
//     ) {
//       alert("Please fill in all required fields.");
//       return;
//     }

//     setIsSubmitting(true);
//     setSubmitStatus(null);

//     try {
//       emailjs.init(EMAILJS_PUBLIC_KEY);

//       const selectedPackage = packages.find(
//         (p) => p.value === formData.package,
//       );

//       const templateParams = {
//         to_email: "info@hnu.ie",
//         from_name: formData.name,
//         from_email: formData.email,
//         package_name: selectedPackage ? selectedPackage.label : "Not specified",
//         package_price: selectedPackage
//           ? selectedPackage.price
//           : "Not specified",
//         appointment_date: formData.date
//           ? formatDate(new Date(formData.date))
//           : "Not specified",
//         appointment_time: formData.time || "Not specified",
//         message: formData.message || "No message provided",
//         turnstile_token: turnstileToken,
//       };

//       const response = await emailjs.send(
//         EMAILJS_SERVICE_ID,
//         EMAILJS_TEMPLATE_ID,
//         templateParams,
//       );

//       console.log("Email sent successfully:", response);
//       setSubmitStatus("success");

//       // Reset form
//       setFormData({
//         name: "",
//         email: "",
//         package: "",
//         date: "",
//         time: "",
//         message: "",
//       });

//       // Reset Turnstile
//       if (window.turnstile && widgetIdRef.current) {
//         try {
//           window.turnstile.reset(widgetIdRef.current);
//         } catch (error) {
//           console.error("Error resetting Turnstile:", error);
//         }
//       }
//       setTurnstileToken(null);

//       setTimeout(() => {
//         onClose();
//         setSubmitStatus(null);
//       }, 2000);
//     } catch (error) {
//       console.error("Error sending email:", error);
//       setSubmitStatus("error");
//       setIsSubmitting(false);
//     }
//   };

//   const handleClose = () => {
//     if (!isSubmitting) {
//       setFormData({
//         name: "",
//         email: "",
//         package: "",
//         date: "",
//         time: "",
//         message: "",
//       });
//       setSubmitStatus(null);
//       setTurnstileToken(null);
//       setTurnstileError(false);

//       // Reset Turnstile widget
//       if (window.turnstile && widgetIdRef.current) {
//         try {
//           window.turnstile.reset(widgetIdRef.current);
//         } catch (error) {
//           console.error("Error resetting Turnstile:", error);
//         }
//       }

//       onClose();
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="modal-overlay" onClick={handleClose}>
//       <div className="modal-container" onClick={(e) => e.stopPropagation()}>
//         <button
//           className="modal-close-btn"
//           onClick={handleClose}
//           disabled={isSubmitting}
//         >
//           <i className="fas fa-times"></i>
//         </button>

//         <h2 className="modal-title">Book an Appointment</h2>
//         <p className="modal-subtitle">
//           Fill in your details and we'll get back to you as soon as possible.
//         </p>

//         {submitStatus === "success" ? (
//           <div className="success-message">
//             <i className="fas fa-check-circle"></i>
//             <p>
//               Your appointment request has been sent successfully! We'll contact
//               you shortly to confirm.
//             </p>
//           </div>
//         ) : (
//           <form ref={formRef} onSubmit={handleSubmit} className="booking-form">
//             {/* Name Field */}
//             <div className="form-group">
//               <label htmlFor="name">Full Name *</label>
//               <input
//                 type="text"
//                 id="name"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//                 placeholder="John Doe"
//                 disabled={isSubmitting}
//               />
//             </div>

//             {/* Email Field */}
//             <div className="form-group">
//               <label htmlFor="email">Email Address *</label>
//               <input
//                 type="email"
//                 id="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//                 placeholder="john@example.com"
//                 disabled={isSubmitting}
//                 className={
//                   formData.email && !validateEmail(formData.email)
//                     ? "invalid"
//                     : ""
//                 }
//               />
//               {formData.email && !validateEmail(formData.email) && (
//                 <p className="field-error">
//                   Please enter a valid email address
//                 </p>
//               )}
//             </div>

//             {/* Package Selection */}
//             <div className="form-group">
//               <label htmlFor="package">Select Package *</label>
//               <select
//                 id="package"
//                 name="package"
//                 value={formData.package}
//                 onChange={handleChange}
//                 required
//                 disabled={isSubmitting}
//                 className="package-select"
//               >
//                 <option value="">Choose a package...</option>
//                 {packages.map((pkg) => (
//                   <option key={pkg.value} value={pkg.value}>
//                     {pkg.label} - {pkg.price} ({pkg.description})
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Date and Time */}
//             <div className="form-row">
//               <div className="form-group form-group-half">
//                 <label htmlFor="date">Appointment Date *</label>
//                 <select
//                   id="date"
//                   name="date"
//                   value={formData.date}
//                   onChange={handleChange}
//                   required
//                   disabled={isSubmitting}
//                   className="date-select"
//                 >
//                   <option value="">Select a date...</option>
//                   {getFutureDates().map((date) => (
//                     <option
//                       key={date.toISOString()}
//                       value={formatDateValue(date)}
//                     >
//                       {formatDate(date)}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="form-group form-group-half">
//                 <label htmlFor="time">Preferred Time *</label>
//                 <select
//                   id="time"
//                   name="time"
//                   value={formData.time}
//                   onChange={handleChange}
//                   required
//                   disabled={isSubmitting}
//                   className="time-select"
//                 >
//                   <option value="">Select a time...</option>
//                   {timeSlots.map((time) => (
//                     <option key={time} value={time}>
//                       {time}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* Message Field */}
//             <div className="form-group">
//               <label htmlFor="message">Brief Message</label>
//               <input
//                 type="text"
//                 id="message"
//                 name="message"
//                 value={formData.message}
//                 onChange={handleChange}
//                 placeholder="Any additional details about your requirements..."
//                 disabled={isSubmitting}
//                 className="message-input"
//               />
//             </div>

//             {/* Cloudflare Turnstile Container */}
//             <div className="form-group turnstile-group">
//               <div
//                 ref={turnstileContainerRef}
//                 id="turnstile-container"
//                 className="turnstile-container"
//               ></div>
//               {turnstileError && (
//                 <p className="turnstile-error">
//                   <i className="fas fa-exclamation-circle"></i>
//                   Please complete the security verification.
//                 </p>
//               )}
//               {turnstileToken && (
//                 <p className="turnstile-success">
//                   <i className="fas fa-check-circle"></i>✓ Verification
//                   successful
//                 </p>
//               )}
//               {!turnstileToken && !turnstileError && (
//                 <p className="turnstile-loading">
//                   <i className="fas fa-spinner fa-spin"></i>
//                   Loading verification...
//                 </p>
//               )}
//             </div>

//             {submitStatus === "error" && (
//               <div className="error-message">
//                 <i className="fas fa-exclamation-circle"></i>
//                 <p>Something went wrong. Please try again later.</p>
//               </div>
//             )}

//             <button
//               type="submit"
//               className="submit-btn"
//               disabled={isSubmitting || !turnstileToken}
//             >
//               {isSubmitting ? (
//                 <>
//                   <span className="spinner"></span>
//                   Sending...
//                 </>
//               ) : (
//                 "Book Appointment"
//               )}
//             </button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BookingModal;

import React, { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "./BookingModal.css";

const BookingModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    package: "",
    date: "",
    time: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [turnstileError, setTurnstileError] = useState(false);
  const [turnstileLoaded, setTurnstileLoaded] = useState(false);

  const formRef = useRef();
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const scriptLoaded = useRef(false);

  // Cloudflare Turnstile Site Key
  const TURNSTILE_SITE_KEY = "0x4AAAAAAESqFbuUZIDyVjHu"; // Replace if needed

  // EmailJS Configuration
  const EMAILJS_SERVICE_ID = "service_990alll";
  const EMAILJS_TEMPLATE_ID = "template_6puxneq";
  const EMAILJS_PUBLIC_KEY = "nw26uUAjZdp_YqTd8";

  // Packages
  const packages = [
    {
      value: "sole-trader",
      label: "Sole Trader/PAYE",
      price: "€150-250",
      description: "Annual Income Tax Return, Revenue compliance",
    },
    {
      value: "sme",
      label: "Small-Medium Enterprises",
      price: "€150-500",
      description: "Monthly bookkeeping, VAT returns, Payroll",
    },
    {
      value: "startup",
      label: "Start-up Business",
      price: "€250",
      description: "CRO registration, Company formation, Revenue Registration",
    },
  ];

  // Generate future dates (tomorrow onwards)
  const getFutureDates = () => {
    const dates = [];
    const today = new Date();
    for (let i = 1; i <= 14; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() + i);
      dates.push(d);
    }
    return dates;
  };

  const formatDate = (date) =>
    date.toLocaleDateString("en-IE", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  const formatDateValue = (date) => date.toISOString().split("T")[0];

  const timeSlots = [
    "09:00",
    "09:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
  ];

  // Load Turnstile script when modal opens
  useEffect(() => {
    if (isOpen && !scriptLoaded.current) {
      const script = document.createElement("script");
      script.src =
        "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      script.onload = () => {
        setTurnstileLoaded(true);
        scriptLoaded.current = true;
        // Render after script loads and container exists
        setTimeout(renderWidget, 100);
      };
      script.onerror = () => setTurnstileError(true);
      document.head.appendChild(script);
    } else if (isOpen && scriptLoaded.current && window.turnstile) {
      // If script already loaded, render directly
      setTimeout(renderWidget, 100);
    }

    return () => {
      // Cleanup on unmount or when modal closes (handled in close)
    };
  }, [isOpen]);

  // Render the Turnstile widget
  const renderWidget = () => {
    if (!window.turnstile || !containerRef.current) return;

    // Remove existing widget if any
    if (widgetIdRef.current) {
      try {
        window.turnstile.remove(widgetIdRef.current);
      } catch (_) {}
      widgetIdRef.current = null;
    }

    try {
      const id = window.turnstile.render(containerRef.current, {
        sitekey: TURNSTILE_SITE_KEY,
        theme: "light",
        size: "normal",
        callback: (token) => {
          setTurnstileToken(token);
          setTurnstileError(false);
        },
        "error-callback": () => {
          setTurnstileToken(null);
          setTurnstileError(true);
        },
        "expired-callback": () => {
          setTurnstileToken(null);
          setTurnstileError(true);
        },
      });
      widgetIdRef.current = id;
    } catch (error) {
      console.error("Turnstile render error:", error);
      setTurnstileError(true);
    }
  };

  // Reset when modal closes
  useEffect(() => {
    if (!isOpen) {
      // Clean up widget
      if (widgetIdRef.current && window.turnstile) {
        try {
          window.turnstile.remove(widgetIdRef.current);
        } catch (_) {}
        widgetIdRef.current = null;
      }
      setTurnstileToken(null);
      setTurnstileError(false);
      setTurnstileLoaded(false);
      // Reset form
      setFormData({
        name: "",
        email: "",
        package: "",
        date: "",
        time: "",
        message: "",
      });
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!turnstileToken) {
      setTurnstileError(true);
      alert("Please complete the security verification.");
      return;
    }

    if (!validateEmail(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    if (
      !formData.name ||
      !formData.package ||
      !formData.date ||
      !formData.time
    ) {
      alert("Please fill in all required fields.");
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      emailjs.init(EMAILJS_PUBLIC_KEY);

      const selectedPackage = packages.find(
        (p) => p.value === formData.package,
      );

      const templateParams = {
        to_email: "info@hnu.ie",
        from_name: formData.name,
        from_email: formData.email,
        package_name: selectedPackage ? selectedPackage.label : "Not specified",
        package_price: selectedPackage
          ? selectedPackage.price
          : "Not specified",
        appointment_date: formData.date
          ? formatDate(new Date(formData.date))
          : "Not specified",
        appointment_time: formData.time || "Not specified",
        message: formData.message || "No message provided",
        turnstile_token: turnstileToken,
      };

      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
      );

      setSubmitStatus("success");

      // Reset form
      setFormData({
        name: "",
        email: "",
        package: "",
        date: "",
        time: "",
        message: "",
      });
      setTurnstileToken(null);
      // Reset Turnstile widget
      if (widgetIdRef.current && window.turnstile) {
        try {
          window.turnstile.reset(widgetIdRef.current);
        } catch (_) {}
      }

      setTimeout(() => {
        onClose();
        setSubmitStatus(null);
      }, 2000);
    } catch (error) {
      console.error("Error sending email:", error);
      setSubmitStatus("error");
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button
          className="modal-close-btn"
          onClick={handleClose}
          disabled={isSubmitting}
        >
          <i className="fas fa-times"></i>
        </button>

        <h2 className="modal-title">Book an Appointment</h2>
        <p className="modal-subtitle">
          Fill in your details and we'll get back to you as soon as possible.
        </p>

        {submitStatus === "success" ? (
          <div className="success-message">
            <i className="fas fa-check-circle"></i>
            <p>
              Your appointment request has been sent successfully! We'll contact
              you shortly to confirm.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="booking-form">
            <div className="form-group">
              <label htmlFor="name">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="John Doe"
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="john@example.com"
                disabled={isSubmitting}
                className={
                  formData.email && !validateEmail(formData.email)
                    ? "invalid"
                    : ""
                }
              />
              {formData.email && !validateEmail(formData.email) && (
                <p className="field-error">
                  Please enter a valid email address
                </p>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="package">Select Package *</label>
              <select
                id="package"
                name="package"
                value={formData.package}
                onChange={handleChange}
                required
                disabled={isSubmitting}
                className="package-select"
              >
                <option value="">Choose a package...</option>
                {packages.map((pkg) => (
                  <option key={pkg.value} value={pkg.value}>
                    {pkg.label} - {pkg.price} ({pkg.description})
                  </option>
                ))}
              </select>
            </div>

            <div className="form-row">
              <div className="form-group form-group-half">
                <label htmlFor="date">Appointment Date *</label>
                <select
                  id="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                  className="date-select"
                >
                  <option value="">Select a date...</option>
                  {getFutureDates().map((date) => (
                    <option
                      key={date.toISOString()}
                      value={formatDateValue(date)}
                    >
                      {formatDate(date)}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group form-group-half">
                <label htmlFor="time">Preferred Time *</label>
                <select
                  id="time"
                  name="time"
                  value={formData.time}
                  onChange={handleChange}
                  required
                  disabled={isSubmitting}
                  className="time-select"
                >
                  <option value="">Select a time...</option>
                  {timeSlots.map((time) => (
                    <option key={time} value={time}>
                      {time}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message">Brief Message</label>
              <input
                type="text"
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Any additional details..."
                disabled={isSubmitting}
                className="message-input"
              />
            </div>

            {/* Turnstile container */}
            <div className="form-group turnstile-group">
              <div
                ref={containerRef}
                id="turnstile-container"
                className="turnstile-container"
              ></div>
              {turnstileError && (
                <p className="turnstile-error">
                  <i className="fas fa-exclamation-circle"></i> Please complete
                  the security verification.
                </p>
              )}
              {turnstileToken && (
                <p className="turnstile-success">
                  <i className="fas fa-check-circle"></i> ✓ Verification
                  successful
                </p>
              )}
              {!turnstileToken && !turnstileError && (
                <p className="turnstile-loading">
                  <i className="fas fa-spinner fa-spin"></i> Loading
                  verification...
                </p>
              )}
            </div>

            {submitStatus === "error" && (
              <div className="error-message">
                <i className="fas fa-exclamation-circle"></i>
                <p>Something went wrong. Please try again later.</p>
              </div>
            )}

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting || !turnstileToken}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner"></span> Sending...
                </>
              ) : (
                "Book Appointment"
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default BookingModal;
